/// <amd-module name="Dashboards/Samples/DashboardsSamplesContext" />
import { WidgetTeamContext } from "Dashboards/WidgetContracts/WidgetProps";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

/*
*   Returns the team associated with a page context
*   @throws if there is no team in the current context
*/
export function getTeam(pageContext: IVssPageContext): WidgetTeamContext {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const teamData = contributionService.getData<any>("ms.vss-dashboards-web.dashboards-team-data-provider");
    if (!teamData || !teamData.value || !teamData.value.id || !teamData.value.name) {
        throw new Error("Couldn't fetch team information.");
    }
    return {
        id: teamData.value.id,
        name: teamData.value.name
    };
}
